/**
 * Do not edit this file directly.
 * 
 * This file is auto-generated during the build process.
 * It defines the global version context for AscendAwesome components.

 */
export const GLOBAL_VERSION_CONTEXT = {
  CDN_ROOT: 'https://static-demo.trustage.com/ascend',
  VERSION: '/lts',
  ENVIRONMENT: 'demo',
  CSS_PATH: '/css',
  JS_PATH: '/js',
}
